import { render, staticRenderFns } from "./InDevelopment.vue?vue&type=template&id=259bac56&scoped=true&"
import script from "./InDevelopment.vue?vue&type=script&lang=ts&"
export * from "./InDevelopment.vue?vue&type=script&lang=ts&"
import style0 from "./InDevelopment.vue?vue&type=style&index=0&id=259bac56&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "259bac56",
  null
  
)

export default component.exports